module.exports = __webpack_public_path__ + "static/bgMobile-min-070ef17fb21a15407c482f83247287a5.jpg";